import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Outlet } from "react-router-dom";
/**
 * Layout component that represents a layout
 */
export class LayoutComponent {
    /**
     *
     * Page path
     */
    _path;
    /**
     * Metadata
     */
    _metadata;
    // Getters
    /**
     * Get page path
     */
    get path() {
        return this._path;
    }
    /**
     * Get metadata
     */
    get metadata() {
        return this._metadata;
    }
    // Setters
    /**
     * Set page path
     */
    set path(path) {
        this._path = path;
    }
    /**
     * Set metadata
     */
    set metadata(metadata) {
        this._metadata = metadata;
    }
    /**
     * Add metadata
     */
    addMetadata(metadata) {
        metadata.forEach(meta => {
            this._metadata.unshift(meta);
        });
    }
    /**
     * Loader method that will be called during a routing on the server side
     * in order to get data for the page from the server
     * @returns Promise<any>
     */
    async loader(_options) {
        return new Promise((resolve) => {
            resolve({
                props: {},
            });
        });
    }
}
/**
 * Default Layout
 */
export class DefaultLayout extends LayoutComponent {
    constructor() {
        super();
        this._path = "/";
    }
    render() {
        return (_jsx(React.Fragment, { children: _jsx(Outlet, {}) }));
    }
}
/**
 * Page component that extends LayoutComponent and represents a page
 */
export class PageComponent extends LayoutComponent {
    /**
     * Page title
     */
    _title;
    /**
     * Page description
     */
    _description;
    // Getters
    /**
     * Get page title
     */
    get title() {
        return this._title;
    }
    /**
     * Get page description
     */
    get description() {
        return this._description;
    }
    // Setters
    /**
     * Set page title
     */
    set title(title) {
        this._title = title;
    }
    /**
     * Set page description
     */
    set description(description) {
        this._description = description;
    }
}
